/*
 * @Author: chengyu
 * @Date: 2022-09-29 11:15:38
 * @Description: 支持 浏览器请求 + node
 * 打包的时候会根据，package.json中的"main"、"browser"字段来区分
 * 浏览器环境与node环境下的入口文件
 */
import fly from 'flyio';
export default (function () {
    return fly;
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYmFzZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb3JlL3JlcXVlc3QvaHR0cC9iYXNlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7R0FNRztBQUVILE9BQU8sR0FBWSxNQUFNLE9BQU8sQ0FBQztBQUVqQyxnQkFBZTtJQUNiLE9BQU8sR0FBRyxDQUFDO0FBQ2IsQ0FBQyxFQUFDIn0=